import { render, staticRenderFns } from "./manitoba.vue?vue&type=template&id=5c926ebf&"
import script from "./manitoba.vue?vue&type=script&lang=js&"
export * from "./manitoba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports